export default "__VITE_ASSET__BljaAGmS__"